import '../App.css';
import React, {Component} from "react";
import {
    AppBar,
    Avatar,
    Badge,
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Container,
    Dialog,
    Divider,
    Fab,
    Fade,
    Grid,
    IconButton,
    InputBase,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText, Menu, MenuItem,
    Pagination,
    Paper,
    Switch,
    Tab,
    Tabs, TextField,
    Toolbar,
    Tooltip,
    Typography,
    Zoom
} from "@mui/material";
import {a11yProps, CenterEmpty, CenterLoading, CustomTabPanel, Slider} from "../functions";
import {
    Add,
    ArrowBack,
    Done,
    DownloadOutlined,
    FavoriteBorderOutlined,
    FavoriteOutlined, HdOutlined,
    PlayCircleOutline, SdOutlined,
    SendOutlined,
    Share,
    Visibility,
    VisibilityOutlined,
    ContentCopyOutlined, LinkRounded, DeleteOutline, ReportOutlined, MoreVertOutlined
} from "@mui/icons-material";
import Grow from "@mui/material/Grow";
import {BottomSheet} from "../bottom_sheet_mui/src/components/BottomSheet";
import $ from "jquery";
import GifLoader from "../GifLoader";

const drawerBleeding = 56;
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Fade ref={ref} {...props} />;
});

// eslint-disable-next-line no-extend-native
Object.defineProperty(Array.prototype, 'array_chunk', {
    value: function(chunkSize) {
        let array = this;
        return [].concat.apply([],
            array.map(function(elem, i) {
                return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
            })
        );
    }
});

class InfoPage extends Component {
    componentDidMount() {
        let url = new URL(window.location.href);
        window.infoPage = this;
        if (navigator.userAgent.includes("OtakuTime")) {
            if (this.isDark()) {
                let item2 = JSON.parse("{}");
                item2.type = "changeTop";
                item2.color = "#182128";
                item2.isDark = "true";
                window.webkit.messageHandlers.m.postMessage(item2);
                let item = JSON.parse("{}");
                item.type = "changeBottom";
                item.color = "#182128";
                item.isDark = "true";
                window.webkit.messageHandlers.m.postMessage(item);
            } else {
                let item2 = JSON.parse("{}");
                item2.type = "changeTop";
                item2.color = "#efeeee";
                item2.isDark = "true";
                window.webkit.messageHandlers.m.postMessage(item2);
                let item = JSON.parse("{}");
                item.type = "changeBottom";
                item.color = "#efeeee";
                item.isDark = "true";
                window.webkit.messageHandlers.m.postMessage(item);
            }
        }
        setTimeout(() => {
            let item = JSON.parse("{}");
            item["value"] = window.main.checkLoggedAndPremium() ? "false" : "true";
            item["type"] = "ads";
            if (window.main.ios()) {
                window.webkit.messageHandlers.callback.postMessage(JSON.stringify(item));
            }
        },1000);
        setTimeout(() => {
            window.main.bannedList();
            let item = JSON.parse("{}");
            item["type"] = "hideBanner";
            if (window.main.ios()) {
                window.webkit.messageHandlers.callback.postMessage(JSON.stringify(item));
            }
        },1000);
        this.getInfo(url.searchParams.get("id"));
    }

    componentWillUnmount() {
        //setTimeout(() => {
        //    //window.main.bannedList();
        //    let item = JSON.parse("{}");
        //    item["type"] = "showBanner";
        //    if (window.main.ios()) {
        //        window.webkit.messageHandlers.callback.postMessage(JSON.stringify(item));
        //    }
        //},500);
    }

    constructor(props) {
        super(props);
        this.state = {
            tabValue:0,
            loading: true,
            data: [],
            infoData: {
                id: "",
                title: "",
                age: "",
                anime_status: "",
                anime_release: "",
                start_date: "",
                score: "",
                type: "",
                story: "",
                image: "",
                youtube: "",
                ep: [],
                other: [],
                youtube_image: "",
                total: "0",
                genre: [],
                season: [],
                reaction: [0, 0, 0, 0, 0, 0]
            },
            otherOne: {},
            otherTwo: {},
            isFav: false,
            infoEpPage: 1,
            favList: [],
            fav: false,
            favLoading: true,
            menuFav: false,
            menuFavData: {},
            menuWatch: false,
            menuWatchData: {},
            epId: "",
            epMenu: false,
            epMenu2: false,
            epMenu3: false,
            epMenu4: false,
            epMenu4List: [],
            epType: 1,
            epLinkType: 1,
            epLink: {},
            animeEpName: "",
            isDark: false,
            imageDialog: false,
            pokemon: {
                like:
                    'data:image/png;base64,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',
                love:
                    'data:image/png;base64,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',
                haha:
                    'data:image/png;base64,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',
                wow:
                    'data:image/png;base64,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',
                sad:
                    'data:image/png;base64,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',
                angry:
                    'data:image/png;base64,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',
            },
            postComment: {
                post: "",
                id: "",
                fire: false
            },
            commentLoading: true,
            commentData: [],
            commentPage: 1,
            fabAdd: false,
            addEp: false,
            epid: 1,
            epsd: "",
            ephd: "",
            otherEpLoading: true,
            otherEpData: [],
            selectServer: false,
            mainServers: false,
            mainItem: {},
            commentAdd: false,
            isDownload: false,
            isHd: false,
            anchorEl: 0,
            menuOpen: false,
            menuId: 0
        };
        window.info = this;
    }
    onCloseMenu = () => {
        this.setState({
            commentAdd: false
        });
    }
    openMenu = () => {
        if (window.main.checkLogged()) {
            this.setState({
                commentAdd: true
            });
            setTimeout(() => {
                document.getElementById("inputComment").addEventListener("keypress", function(event) {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        window.info.sendCmd();
                    }
                });
            },600);
        } else {
            window.main.showMessage("يرجى تسجيل الدخول","الحساب","حسنا","",true);
        }
    }
    getInfo = (id) => {
        this.checkFav(id);
        this.setState({
            loading: true
        })
        let url = 'https://app.sanime.net/function/h10.php?page=info&id='+id;
        if (this.checkLogged()) {
            url = 'https://app.sanime.net/function/h10.php?page=info&id='+id+'&email='+this.accountData().email;
        }
        fetch(url).then((value) => {
            value.text().then((value) => {
                const data = JSON.parse(value);
                let genre = "";
                data.genre.forEach((item) => {
                    genre = genre + " , " + item.name;
                });
                genre = genre.substr(2,genre.length);
                this.setState({
                    info: true,
                    loading: false,
                    selectedInfo: 0,
                    infoEpPage: 1,
                    infoData: {
                        id: data.id,
                        title: data.name,
                        age: data.anime_age,
                        anime_status: data.anime_status,
                        anime_release: data.anime_release,
                        start_date: data.start_date,
                        score: data.score,
                        type: data.type,
                        genre: genre,
                        story: data.story,
                        image: data.tag,
                        youtube: "",
                        ep: data.ep,
                        other: data.other,
                        youtube_image: data.youtube_link,
                        total: data.total,
                        season: data.season,
                        reaction: data.reactList,
                        userIp: data.userIp
                    },
                    otherOne: data.other[Math.floor(Math.random()*data.other.length)],
                    otherTwo: data.other[Math.floor(Math.random()*data.other.length)],
                    epMenu: false,
                    epMenu2: false,
                    epMenu3: false,
                    epLink: '',
                    animeEpName: '',
                    epLinkType: '',
                    backdrop: false
                });
                if (window.main.android()) {
                    if (window.main.checkTheme()) {
                        window.Android.setNav("#262e39");
                        window.Android.setStatus("#182128");
                    } else {
                        window.Android.setNav("#ffffff");
                        window.Android.setStatus("#efeeee");
                    }
                } else {
                    if (navigator.userAgent.includes("OtakuTime")) {
                        if (this.isDark()) {
                            let item = JSON.parse("{}");
                            item.type = "changeBottom";
                            item.color = "#262e39";
                            item.isDark = "true";
                            window.webkit.messageHandlers.m.postMessage(item);
                        } else {
                            let item = JSON.parse("{}");
                            item.type = "changeBottom";
                            item.color = "#ffffff";
                            item.isDark = "false";
                            window.webkit.messageHandlers.m.postMessage(item);
                        }
                    }
                }
                if (window.navigator.userAgent.includes("SAnimeWeb")) {
                    let item = JSON.parse("{}");
                    item.type = "changeTitle";
                    item.title = data.name;
                    window.chrome.webview.postMessage(JSON.stringify(item));
                }
            });
        }).catch((err) => {
            window.location.href = "/";
        });
    }
    innerWidth = () => {
        return window.innerWidth;
    }
    innerHeight = () => {
        return window.innerHeight;
    }
    handleChange = (event, newValue) => {
        if (newValue === 2) {
            this.getCMD();
        }
        this.setState({
            tabValue: newValue
        });
    };
    addReact = (value) => {
        if (value.includes("like")) {
            value = 0;
        } else {
            if (value.includes("love")) {
                value = 1;
            } else {
                if (value.includes("haha")) {
                    value = 2;
                } else {
                    if (value.includes("wow")) {
                        value = 3;
                    } else {
                        if (value.includes("sad")) {
                            value = 4;
                        } else {
                            //angry;
                            value = 5;
                        }
                    }
                }
            }
        }
        let data = JSON.parse("{}");
        data.animeid = this.state.infoData.id;
        data.type = value;
        window.main.switchLoading();
        fetch('https://app.sanime.net/function/h10.php?page=addReact&id='+data.animeid+'&type='+value).then((value) => {
            value.text().then((value) => {
                const data = JSON.parse(value);
                this.setState({
                    infoData: {
                        id: this.state.infoData.id,
                        title: this.state.infoData.title,
                        age: this.state.infoData.age,
                        anime_status: this.state.infoData.anime_status,
                        anime_release: this.state.infoData.anime_release,
                        start_date: this.state.infoData.start_date,
                        score: this.state.infoData.score,
                        type: this.state.infoData.type,
                        genre: this.state.infoData.genre,
                        story: this.state.infoData.story,
                        image: this.state.infoData.image,
                        youtube: this.state.infoData.youtube,
                        ep: this.state.infoData.ep,
                        other: this.state.infoData.other,
                        youtube_image: this.state.infoData.youtube_image,
                        total: this.state.infoData.total,
                        season: this.state.infoData.season,
                        reaction: data,
                        userIp: this.state.infoData.userIp
                    }
                });
                window.main.switchLoading();
            });
        });
    }
    addFav = () => {
        let title = this.state.infoData.title;
        let image = this.state.infoData.image;
        let id = this.state.infoData.id;
        if (localStorage.getItem("INFO_"+id)) {
            localStorage.removeItem("INFO_"+id);
            this.setState({isFav: false});
        } else {
            let infoDat = {
                "title": title,
                "image": image,
                "id": id
            }
            localStorage.setItem("INFO_"+id,JSON.stringify(infoDat));
            this.setState({isFav: true});
        }
    }
    checkFav = (id) => {
        if (localStorage.getItem("INFO_"+id)) {
            this.setState({isFav: true})
            return true;
        } else {
            this.setState({isFav: false})
            return false;
        }
    }
    infoEpChanged = (event, value) => {
        this.setState({infoEpPage: value});
    }
    addWatch = (epId,epName) => {
        this.setState({
           loading:true
        });
        let title = this.state.infoData.title;
        let image = this.state.infoData.image;
        let id = this.state.infoData.id;
        if (localStorage.getItem("WATCH_"+id)) {
            let epLst = JSON.parse(localStorage.getItem("WATCH_"+id));
            for (let index = 0; index < epLst.ep.length; ++index) {
                const ids = epLst.ep[index];
                if(ids.id === epId){
                    break;
                } else {
                    let epData = {
                        "id": epId,
                        "name": epName
                    }
                    epLst.ep.push(epData);
                    break;
                }
            }
            localStorage.removeItem("WATCH_"+id);
            let infoDat = {
                "title": title,
                "image": image,
                "id": id,
                "ep": epLst.ep
            }
            localStorage.setItem("WATCH_"+id,JSON.stringify(infoDat));
        } else {
            let infoDat = {
                "title": title,
                "image": image,
                "id": id,
                "ep": []
            }
            let epData = {
                "id": epId,
                "name": epName
            }
            infoDat.ep.push(epData);
            localStorage.setItem("WATCH_"+id,JSON.stringify(infoDat));
        }
        this.setState({
            loading:false
        });
    }
    checkWatch = (epId,epName) => {
        let id = this.state.infoData.id;
        if (localStorage.getItem("WATCH_"+id)) {
            let epLst = JSON.parse(localStorage.getItem("WATCH_"+id));
            let js = JSON.stringify(epLst.ep);
            return js.includes('{"id":"'+epId+'","name":"'+epName+'"}');
        } else {
            return false;
        }
    }
    commentPageChanged = (event, value) => {
        this.setState({commentPage: value});
    }
    hasFireChanged = (value) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.postComment.fire = value.target.checked;
        const newValue = this.state.postComment;
        this.setState({
            postComment: newValue
        });
    }
    changeFire = (index) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.commentData[this.state.commentPage - 1][index].hasFire = !this.state.commentData[this.state.commentPage - 1][index].hasFire;
        const newValue = this.state.commentData;
        this.setState({
            commentData: newValue
        });
    }
    isDark = () => {
        if (localStorage.getItem("theme") !== null) {
            return localStorage.getItem("theme").includes("true");
        } else {
            return true
        }
    }
    getCMD = () => {
        this.setState({
            commentLoading: true,
            commentData: [],
            postComment: {
                post: '',
                id: this.state.infoData.id,
                fire: false
            },
        });
        fetch('https://app.sanime.net/function/h10.php?page=animeCmd&id=' + this.state.infoData.id).then((response) => {
            response.json().then((va) => {
                this.setState({
                    commentLoading: false,
                    commentData: va.array_chunk(25)
                });
            });
        }).catch((err) => {
            this.setState({
                selectedInfo: 0
            });
        });
    }
    sendCmd = () => {
        if (this.state.postComment.post.length < 2) {
            window.main.showMessage("يجب على تعليقك أن يكون حرفين أو أكثر","تنبيه","حسنا","",true);
        } else {
            if (localStorage.getItem("logged") !== null) {
                window.main.switchLoading();
                let data = JSON.parse(localStorage.getItem("loggedData"));
                const formData = new URLSearchParams();
                formData.append('email', data.email);
                formData.append('password', data.password);
                formData.append('item', btoa(unescape(encodeURIComponent(JSON.stringify(this.state.postComment)))));

                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: formData

                };
                fetch('https://app.sanime.net/function/h10.php?page=addcmd', requestOptions).then((response) => {
                    response.json().then((va) => {
                        if (va.status === 1) {
                            window.main.showMessage(va.message,"تنبيه","حسنا","",true);
                            this.setState({
                                commentAdd: false,
                                postComment: {
                                    post: "",
                                    id: ""
                                },
                            });
                            this.getCMD();
                            window.main.switchLoading();
                        } else {
                            this.setState({
                                postComment: {
                                    post: "",
                                    id: ""
                                },
                            });
                            window.main.showMessage(va.message,"تنبيه","حسنا","",true);
                            window.main.switchLoading();
                        }
                    });
                }).catch((err) => {
                    this.setState({
                        postComment: {
                            post: "",
                            id: ""
                        },
                    });
                    window.main.showMessage("توجد مشكلة حاول مجددا","تنبيه","حسنا","",true);
                    window.main.switchLoading();
                });
            } else {
                this.setState({
                    postComment: {
                        post: "",
                        id: ""
                    },
                });
                window.main.showMessage("يجب عليك تسجيل الدخول لأضافة تعليق","تنبيه","حسنا","",true);
            }
        }
    }
    goSendRequest = () => {
        window.main.showMessage("تم أرسال الطلب","تنبيه","حسنا","",true);
        //fetch('https://app.sanime.net/secure/request.php?name='+this.state.infoData.title+"&id="+this.state.infoData.id).then((value) => {}).catch(() => {});
    }
    epMenu = (data,name) => {
        if (window.main.checkLoggedAndPremium()) {
            this.setState({
                epMenu: true,
                epLink: data,
                animeEpName: name
            });
        } else {
            this.setState({
                epMenu: true,
                epLink: data,
                animeEpName: name
            });
            if (window.main.android()) {
                window.main.openFull();
            }
        }
    }
    closeMenu = () => {
        this.setState({
            epMenu: false
        });
    }
    epMenu2 = (value) => {
        this.setState({
            epMenu2: true,
            epType: value,
            epMenu: false
        });
    }
    epMenu2Close = () => {
        this.setState({
            epMenu2: false
        });
    }
    epMenu3 = (value) => {
        if (this.state.epType !== 1) {
            //this.showAds();
        }
        this.setState({
            epMenu3: true,
            epMenu2: false,
            epLinkType: value
        });
    }
    epMenu3Close = () => {
        this.setState({
            epMenu3: false
        });
    }
    epMenu4Close = () => {
        this.setState({
            epMenu4: false,
            epMenu4List: []
        });
    }
    showEp = (data) => {
        this.setState({
            mainItem: data
        });
        let ep = btoa(unescape(encodeURIComponent(JSON.stringify(data))));
        let epInfo = data;
        window.main.switchLoading();
        fetch('https://app.sanime.net/function/h10.php?page=openAnd&id='+ep).then((value) => {
            window.main.switchLoading();
            value.text().then((value) => {
                const data = JSON.parse(value);
                this.epMenu(data,epInfo.name);
                this.addWatch(epInfo.id,epInfo.name);
                this.setState((state, props) => ({
                    infoData: state.infoData
                }));
            });
        }).catch((er) => {
            window.main.switchLoading();
        });
    }
    open = (type) => {
        const data = this.state.epLink;
        let item = JSON.parse("{}");
        let color = JSON.parse("{}");
        switch (type) {
            case 1:
                if (window.main.ios()) {
                    this.setState({
                        isDownload: false,
                        epMenu: false,
                        epMenu2: true
                    });
                    //window.webkit.messageHandlers.callback.postMessage(JSON.stringify({
                    //    "type": "play",
                    //    "sd": data.sd,
                    //    "hd": data.hd,
                    //    "player": "snoanime",
                    //}));
                } else {
                    this.setState({
                        isDownload: false,
                        epMenu: false,
                        epMenu2: true
                    });
                }
                break;
            case 2:
                if (window.main.ios()) {
                    color["rr"] = this.isDark() ? "38" : "255";
                    color["gg"] = this.isDark() ? "46" : "255";
                    color["bb"] = this.isDark() ? "57" : "255";
                    window.webkit.messageHandlers.callback.postMessage(JSON.stringify({
                        "type": "download",
                        "sd": data.sd,
                        "hd": data.hd,
                        "player": "snoanime",
                        "cc":color
                    }));
                } else {
                    if (window.main.isXbox()) {
                        // eslint-disable-next-line no-undef
                        Swal.fire(
                            "التنزيل حاليا غير متاح على اجهزة الاكسبوكس"
                        );
                    } else {
                        this.setState({
                            isDownload: true,
                            epMenu: false,
                            epMenu2: true
                        });
                    }
                }
                break;
            case 3:
                color["rr"] = this.isDark() ? "38" : "255";
                color["gg"] = this.isDark() ? "46" : "255";
                color["bb"] = this.isDark() ? "57" : "255";
                window.webkit.messageHandlers.callback.postMessage(JSON.stringify({
                    "type": "play",
                    "sd": "https://ok.ru/videoembed/6348942936651",
                    "hd": "https://ok.ru/videoembed/6348942936651",
                    "player": "web",
                    "cc":color
                }));
                break;
            case 4:
                let old = btoa(unescape(encodeURIComponent(JSON.stringify(data))));
                color["rr"] = this.isDark() ? "38" : "255";
                color["gg"] = this.isDark() ? "46" : "255";
                color["bb"] = this.isDark() ? "57" : "255";
                window.webkit.messageHandlers.callback.postMessage(JSON.stringify({
                    "type": "old",
                    "data": old
                }));
                break;
            case 7:
                this.setState({
                    epMenu: false,
                    epMenu2: false,
                    epMenu3: false
                });
                if (window.main.android()) {
                    if (this.state.isHd) {
                        window.Android.download(this.state.epLink.hd,this.state.infoData.title + " " + this.state.animeEpName + ".mp4");
                    } else {
                        window.Android.download(this.state.epLink.sd,this.state.infoData.title + " SD " + this.state.animeEpName + ".mp4");
                    }
                } else {
                    if (window.main.isOtakuTime()) {
                        let item = JSON.parse("{}");
                        item.type = "copyLink";
                        if (this.state.isHd) {
                            item.link = this.state.epLink.hd;
                        } else {
                            item.link = this.state.epLink.sd;
                        }
                        window.webkit.messageHandlers.m.postMessage(item);
                        // eslint-disable-next-line no-undef
                        Swal.fire(
                            "تم نسخ رابط الحلقة قم بتحميلها عن طريق أي تطبيق أو من خلال" +
                            "\n" +
                            "VLC"
                        );
                    }
                }
                break;
            case 8:
                this.setState({
                    epMenu: false,
                    epMenu2: false,
                    epMenu3: false
                });
                if (window.main.android()) {
                    if (this.state.isHd) {
                        window.Android.adm(this.state.epLink.hd,this.state.infoData.title + " " + this.state.animeEpName);
                    } else {
                        window.Android.adm(this.state.epLink.sd,this.state.infoData.title + " SD " + this.state.animeEpName);
                    }
                }
                break;
            case 9:
                this.setState({
                    epMenu: false,
                    epMenu2: false,
                    epMenu3: false
                });
                if (window.main.android()) {
                    if (this.state.isHd) {
                        window.Android.otherDownload(this.state.epLink.hd,this.state.infoData.title + " " + this.state.animeEpName + ".mp4");
                    } else {
                        window.Android.otherDownload(this.state.epLink.sd,this.state.infoData.title + " SD " + this.state.animeEpName + ".mp4");
                    }
                }
                break;
            case 10:
                this.setState({
                    epMenu: false,
                    epMenu2: false,
                    epMenu3: false
                });
                if (this.state.isHd) {
                    this.goPlayer("true");
                } else {
                    this.goPlayer("false");
                }
                break;
            case 11:
                this.setState({
                    epMenu: false,
                    epMenu2: false,
                    epMenu3: false
                });
                if (window.main.android()) {
                    if (this.state.isHd) {
                        window.Android.otherPlayer(this.state.epLink.hd,this.state.infoData.title + " " + this.state.animeEpName);
                    } else {
                        window.Android.otherPlayer(this.state.epLink.sd,this.state.infoData.title + " " + this.state.animeEpName);
                    }
                } else {
                    if (window.main.ios()) {
                        const dummy = document.createElement("textarea");
                        if (this.state.isHd) {
                            dummy.value = this.state.epLink.hd;
                        } else {
                            dummy.value = this.state.epLink.sd;
                        }
                        document.body.appendChild(dummy);
                        dummy.select();
                        document.execCommand("copy");
                        document.body.removeChild(dummy);
                        // eslint-disable-next-line no-undef
                        Swal.fire(
                            "تم نسخ رابط الحلقة قم بتشغيلها عن طريق أي تطبيق أو من خلال" +
                            "\n" +
                            "VLC"
                        );
                    } else {
                        if (navigator.userAgent.includes("SAnimeWeb")) {
                            let copyText = document.createElement("input");
                            if (this.state.isHd) {
                                copyText.value = this.state.epLink.hd;
                            } else {
                                copyText.value = this.state.epLink.sd;
                            }
                            copyText.select();
                            copyText.setSelectionRange(0, 99999); // For mobile devices
                            navigator.clipboard.writeText(copyText.value).then(r => () => {
                                //copy
                            });
                            // eslint-disable-next-line no-undef
                            Swal.fire(
                                "تم نسخ رابط الحلقة قم بتشغيلها عن طريق أي تطبيق أو من خلال" +
                                "\n" +
                                "VLC"
                            );
                        }
                    }
                }
                break;
            default :
                if (window.main.ios()) {
                    item["sd"] = btoa(unescape(encodeURIComponent(JSON.stringify(data))));
                    item["hd"] = "";
                    item["player"] = "web";
                    item["type"] = "old";
                    this.closeMenu();
                    if (navigator.userAgent.includes("SevenZero")) {
                        window.webkit.messageHandlers.callback.postMessage(JSON.stringify(item));
                    }
                } else {
                    this.setState({
                        isDownload: false,
                        epMenu: false,
                        epMenu2: true
                    })
                }
                break;
        }
    }

    checkLogged = () => {
        return localStorage.getItem("logged") !== null;
    }
    accountData = () => {
        if (this.checkLogged()) {
            return JSON.parse(localStorage.getItem("loggedData"));
        }
    }

    goPlayer = (type) => {
        window.localStorage.setItem("hdUrl",this.state.epLink.hd);
        window.localStorage.setItem("sdUrl",this.state.epLink.sd);
        window.localStorage.setItem("isHd",type);
        window.localStorage.setItem("videoName",this.state.infoData.title + " " + this.state.animeEpName);
        if (type.includes("true")) {
            window.localStorage.setItem("plyr",'{"quality":720}');
        } else {
            window.localStorage.setItem("plyr",'{"quality":360}');
        }
        window.main.goLink("/player");
    }

    goPlayerWeb = () => {
        window.localStorage.setItem("webUrl",this.state.epLink.hd);
        window.localStorage.setItem("videoName",this.state.infoData.title + " " + this.state.animeEpName);
        window.main.goLink("/playerWeb");
    }

    goBack = () => {
        window.main.goLink("/");
        if (navigator.userAgent.includes("OtakuTime")) {
            if (this.isDark()) {
                let item = JSON.parse("{}");
                item.type = "changeBottom";
                item.color = "#182128";
                item.isDark = "true";
                window.webkit.messageHandlers.m.postMessage(item)
            } else {
                let item = JSON.parse("{}");
                item.type = "changeBottom";
                item.color = "#efeeee";
                item.isDark = "false";
                window.webkit.messageHandlers.m.postMessage(item)
            }
        }
        if (window.navigator.userAgent.includes("SAnimeWeb")) {
            let item = JSON.parse("{}");
            item.type = "changeTitle";
            item.title = "الرئيسية";
            window.chrome.webview.postMessage(JSON.stringify(item));
        }
    }
    closeMenus = () => {
        this.setState({
            anchorEl: null,
            menuOpen: false,
        });
    }

    sendReport = (item) => {
        console.log("sendReport");
        this.setState({
            anchorEl: null,
            menuOpen: false,
        });
        window.main.switchLoading();
        fetch('https://app.sanime.net/function/h10.php?page=sendReport', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                id: item.id,
                animeId: this.state.infoData.id
            })
        }).then((response) => {
            response.json().then((va) => {
                window.main.switchLoading();
                window.main.showMessage(va.message,"تنبيه","حسنا","",true);
            });
        }).catch((err) => {
            window.main.switchLoading();
        });
    }

    deleteCmdAnime = (item) => {
        this.setState({
            anchorEl: null,
            menuOpen: false,
        });
        if (localStorage.getItem("logged") !== null) {
            let data = JSON.parse(localStorage.getItem("loggedData"));
            window.main.switchLoading();
            fetch('https://app.sanime.net/function/h10.php?page=deleteCmdPost', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    password: data.password,
                    email: data.email,
                    userId: data.id,
                    id: item.id,
                    animeId: this.state.infoData.id
                })
            }).then((response) => {
                response.json().then((va) => {
                    window.main.switchLoading();
                    if (va.status === 1) {
                        window.main.showMessage(va.message,"تنبيه","حسنا","",true);
                    } else {
                        window.main.showMessage(va.message,"تنبيه","حسنا","",true);
                    }
                    this.getCMD();
                });
            }).catch((err) => {
                window.main.switchLoading();
                window.main.showMessage("توجد مشكلة حاول مجددا","تنبيه","حسنا","",true);
                this.getCMD();
            });
        } else {
            window.main.switchLoading();
            window.main.showMessage("توجد مشكلة حاول مجددا","تنبيه","حسنا","",true);
            this.getCMD();
        }
    }

    isAdmin = () => {
        if (localStorage.getItem("logged") !== null) {
            let data = JSON.parse(localStorage.getItem("loggedData"));
            return !!data.isAdmin.includes("true");
        } else {
            return false;
        }
    }

    reportCmd = (event) => {
        this.setState({
            anchorEl: event.currentTarget,
            menuOpen: true,
            menuId: event.currentTarget.id
        });
    }

    render() {
        let youtube;
        if (this.state.infoData.youtube_image.toString().length > 1) {
            youtube = <ListItem>
                <Container disableGutters>
                    <Card style={{alignItems: "center"}}>
                        <div style={{borderRadius: '10px',overflow: 'hidden',width: "100%",display: "flex", height: "fit-content"}}>
                            <iframe title={"youtubeFrame"} style={{width: "100%"}} height="230" src={this.state.infoData.youtube_image} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>
                        </div>
                    </Card>
                </Container>
            </ListItem>;
        } else {
            youtube = <Box/>;
        }
        if (this.state.loading) {
            return ( <CenterLoading/> );
        } else {
            return (<Box sx={{ flexGrow: 1,height: "100%",position: 'relative' }} className={this.isDark() ? "centerColorD" : "centerColorL"}>
                <AppBar position="static" color="background" enableColorOnDark elevation={0}>
                    <Toolbar>
                        <IconButton
                            onClick={this.goBack.bind(this)}
                            size="medium"
                            edge="start"
                            color="inherit"
                            aria-label="back"
                            sx={{ marginRight: "0px" }}
                        >
                            <ArrowBack />
                        </IconButton>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1,textAlign: "center",fontSize: "17px",fontFamily: "Righteous",paddingRight: "9px" }} className={"oneLine"}>
                            {this.state.infoData.title}
                        </Typography>
                        <IconButton
                            onClick={() => {
                                if (window.main.android()) {
                                    window.main.showMessage("الخيار غير مكتمل","تنبيه","حسنا","",false);
                                } else {
                                    if (window.main.ios()) {
                                        let item = JSON.parse("{}");
                                        item["title"] = this.state.infoData.title;
                                        item["txt"] = "يمكنكم الأن متابعة أنمي " + this.state.infoData.title + "\n" + "على تطبيقنا " + "\n" + "https://apps.apple.com/us/app/snoanime/id1457590939?platform=iphone";
                                        item["type"] = "share";
                                        if (navigator.userAgent.includes("SevenZero")) {
                                            window.webkit.messageHandlers.callback.postMessage(JSON.stringify(item));
                                        }
                                    }
                                }
                            }}
                            size="medium"
                            edge="start"
                            color="inherit"
                            aria-label="share"
                            sx={{ marginRight: "0px" }}
                        >
                            <Share />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Box sx={{textAlign:"-webkit-center"}}>
                    <Grid container spacing={3} sx={{alignItems: "center"}}>
                        {
                            this.innerWidth() > 914 ? <Grid item xs>
                                <Box onClick={this.getInfo.bind(this,this.state.otherOne.id)} style={{maxWidth: "280px",borderRadius: "8px 8px 8px 8px",width:"100%",height: "140px",background: "url("+this.state.otherOne.image+") center center",backgroundSize: "cover"}} className={"iphoneBack"}>
                                    <Box style={{width: "100%", height: "100%"}}/>
                                </Box>
                            </Grid> : <Grid item xs>
                                <Box onClick={this.getInfo.bind(this,this.state.otherOne.id)} style={{maxWidth: "280px",borderRadius: "0px 8px 8px 0px",width:"100%",height: "140px",background: "url("+this.state.otherOne.image+") center center",backgroundSize: "cover"}} className={"iphoneBack"}>
                                    <Box style={{width: "100%", height: "100%"}}/>
                                </Box>
                            </Grid>
                        }
                        {
                            this.innerWidth() > 819 ? <Grid item xs>
                                <Slider key={1} value={0} index={0}>
                                    <Card style={{maxWidth: "280px",borderRadius:"8px",width:"100%",height: "170px",background: "url("+this.state.infoData.image+") center center",backgroundSize: "contain"}} className={"iphoneBack"}>
                                        <Box style={{width:"100%",height: "100%"}}>
                                            <Card sx={{display: 'flex', height: "100%", padding: "7px", background: "transparent"}}/>
                                        </Box>
                                    </Card>
                                </Slider>
                            </Grid> : <Grid item xs={9}>
                                <Slider key={1} value={0} index={0}>
                                    <Card style={{maxWidth: "280px",borderRadius:"8px",width:"100%",height: "170px",background: "url("+this.state.infoData.image+") center center",backgroundSize: "contain"}} className={"iphoneBack highShadow"}>
                                        <Box style={{width:"100%",height: "100%"}}>
                                            <Card sx={{display: 'flex', height: "100%", padding: "7px", background: "transparent"}}/>
                                        </Box>
                                    </Card>
                                </Slider>
                            </Grid>
                        }
                        {
                            this.innerWidth() > 914 ? <Grid item xs>
                                <Box onClick={this.getInfo.bind(this,this.state.otherTwo.id)} style={{maxWidth: "280px",borderRadius: "8px 8px 8px 8px",width:"100%",height: "140px",background: "url("+this.state.otherTwo.image+") center center",backgroundSize: "cover"}} className={"iphoneBack"}>
                                    <Box style={{width: "100%", height: "100%"}}/>
                                </Box>
                            </Grid> : <Grid item xs>
                                <Box onClick={this.getInfo.bind(this,this.state.otherTwo.id)} style={{maxWidth: "280px",borderRadius: "8px 0px 0px 8px",width:"100%",height: "140px",background: "url("+this.state.otherTwo.image+") center center",backgroundSize: "cover"}} className={"iphoneBack"}>
                                    <Box style={{width: "100%", height: "100%"}}/>
                                </Box>
                            </Grid>
                        }
                    </Grid>
                </Box>
                <Box sx={{
                    backgroundColor: "primary.card",
                    top: -drawerBleeding,
                    borderTopLeftRadius: 14,
                    borderTopRightRadius: 14,
                    visibility: 'visible',
                    right: 0,
                    left: 0,
                    textAlign: "-webkit-center",
                    marginTop: "43px"
                }}>
                    <Box sx={{paddingBottom: "6px"}}/>
                    <Box sx={{
                        width: 30,
                        height: 6,
                        backgroundColor: "text.sec",
                        marginTop: "10px",
                        borderRadius: 3,
                        paddingBottom: "6px",
                        left: 'calc(50% - 15px)',
                    }} />
                    <Box sx={{width: "100%",maxWidth: "450px"}}>
                        <Box sx={{ margin:"10px", backgroundColor: "background.paper",borderRadius: "100px" }} className={"smallShadow"}>
                            <Tabs value={this.state.tabValue} onChange={this.handleChange} aria-label="infoPage" centered TabIndicatorProps={{
                                title: "indicator",
                                hidden: true,
                            }} className={"tabsRoot"}>
                                <Tab style={{fontFamily: "Changa",borderRadius:"100px",margin: "5px 0px 5px 0px"}} label="المعلومات" className={window.main.state.mode === "dark" ? "myTabD tabRoot" : "myTabL tabRoot"} {...a11yProps(0)} />
                                {
                                    this.state.infoData.ep.length === 0 ? <Box style={{display: "none"}}/> : <Tab style={{fontFamily: "Changa",borderRadius:"100px",margin: "5px 0px 5px 0px"}} label="الحلقات" className={window.main.state.mode === "dark" ? "myTabD tabRoot" : "myTabL tabRoot"} {...a11yProps(1)} />
                                }
                                <Tab style={{fontFamily: "Changa",borderRadius:"100px",margin: "5px 0px 5px 0px"}} label="التعليقات" className={window.main.state.mode === "dark" ? "myTabD tabRoot" : "myTabL tabRoot"} {...a11yProps(2)} />
                            </Tabs>
                        </Box>
                        <CustomTabPanel value={this.state.tabValue} index={0}>
                            <Grow in={this.state.tabValue === 0}>
                                <List dense sx={{padding: "2px 0px 8px 0px"}}>
                                    <ListItem>
                                        <ListItemText
                                            primary={this.state.infoData.title}
                                            secondary={this.state.infoData.genre}
                                            secondaryTypographyProps={{
                                                sx: {
                                                    fontFamily: "'Changa'",
                                                    fontSize: "14px",
                                                    width: "80&"
                                                },
                                            }}
                                            primaryTypographyProps={{
                                                sx: {
                                                    fontFamily: "Righteous",
                                                    fontSize: "17px",
                                                    width: "80&"
                                                },
                                                className: "oneLine"
                                            }}
                                        />
                                        <IconButton onClick={this.addFav} className={"smallShadow"} sx={{backgroundColor: "primary.card",color: "text.primary"}} ria-label="add an fav">
                                            {
                                                this.state.isFav ? <FavoriteOutlined /> : <FavoriteBorderOutlined />
                                            }
                                        </IconButton>
                                    </ListItem>
                                    <ListItem>
                                        <Grid container spacing={3}>
                                            <Grid xs item={true}>
                                                <Box>
                                                    <Paper sx={{
                                                        borderRadius: "11px",
                                                        backgroundImage: "unset",
                                                        backgroundColor: "primary.card",
                                                        textAlign: 'center',
                                                        height: 90
                                                    }} className={this.isDark() ? "columnItem linedShadowDInfo" : "columnItem linedShadowLInfo"}>
                                                    <span style={{fontFamily: "'Changa'"}}>
                                                        التقيم
                                                    </span>
                                                        <span style={{fontSize: "12px",fontFamily: "'Changa'"}}>
                                                        {this.state.infoData.score === "null" ? "7.2" : this.state.infoData.score}
                                                    </span>
                                                    </Paper>
                                                </Box>
                                            </Grid>
                                            <Grid xs item={true}>
                                                <Box>
                                                    <Paper sx={{
                                                        borderRadius: "11px",
                                                        backgroundImage: "unset",
                                                        backgroundColor: "primary.card",
                                                        textAlign: 'center',
                                                        height: 90,
                                                    }} className={this.isDark() ? "columnItem linedShadowDInfo" : "columnItem linedShadowLInfo"}>
                                                    <span style={{fontFamily: "'Changa'"}}>
                                                        الحلقات
                                                    </span>
                                                        <span style={{fontSize: "12px",fontFamily: "'Changa'"}}>
                                                        {this.state.infoData.total}
                                                    </span>
                                                    </Paper>
                                                </Box>
                                            </Grid>
                                            <Grid xs item={true}>
                                                <Box>
                                                    <Paper sx={{
                                                        borderRadius: "11px",
                                                        backgroundImage: "unset",
                                                        backgroundColor: "primary.card",
                                                        textAlign: 'center',
                                                        height: 90,
                                                    }} className={this.isDark() ? "columnItem linedShadowDInfo" : "columnItem linedShadowLInfo"}>
                                                    <span style={{fontFamily: "'Changa'"}}>
                                                        النوع
                                                    </span>
                                                        <span style={{fontSize: "12px",fontFamily: "'Changa'"}}>
                                                        {this.state.infoData.type}
                                                    </span>
                                                    </Paper>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </ListItem>
                                    <ListItem>
                                        <Box className={"titleHeader"} sx={{marginTop:"8px"}}>
                                            <Button size="medium" disabled={true} style={{color: "white"}}>
                                                <span/>
                                            </Button>
                                            <div>
                                                <span style={{fontFamily: "Changa",fontSize: "17px"}}>قصة الأنمي</span>
                                            </div>
                                        </Box>
                                    </ListItem>
                                    <ListItem sx={{marginTop: "0px",opacity:"0.8"}}>
                                        <Typography sx={{fontFamily: "Changa",textAlign: "end",fontSize: "15px",width: "100%"}}>
                                            {this.state.infoData.story}
                                        </Typography>
                                    </ListItem>
                                    <ListItem>
                                        <Box className={"titleHeader"} sx={{marginTop:"8px"}}>
                                            <Button size="medium" disabled={true} style={{color: "white"}}>
                                                <span/>
                                            </Button>
                                            <div>
                                                <span style={{fontFamily: "Changa",fontSize: "17px"}}>معلومات اخرى</span>
                                            </div>
                                        </Box>
                                    </ListItem>
                                    <ListItem sx={{marginTop: "0px",opacity:"0.8"}}>
                                        <Typography sx={{fontFamily: "Changa",textAlign: "end",fontSize: "15px",width: "100%"}}>
                                            حالة الأنمي : {this.state.infoData.anime_status}
                                        </Typography>
                                        <Typography sx={{fontFamily: "Changa",textAlign: "start",fontSize: "15px",width: "100%",direction: "rtl"}}>
                                            التصنيف العمري : {this.state.infoData.age}
                                        </Typography>
                                    </ListItem>
                                    <ListItem>
                                        <Box className={"titleHeader"} sx={{marginTop:"8px"}}>
                                            <Button size="medium" disabled={true} style={{color: "white"}}>
                                                <span/>
                                            </Button>
                                            <div>
                                                <span style={{fontFamily: "Changa",fontSize: "17px"}}>تقيمات المستخدمين</span>
                                            </div>
                                        </Box>
                                    </ListItem>
                                    <ListItem>
                                        <Container disableGutters>
                                            <Card elevation={0} sx={{backgroundColor: "transparent"}} className={this.isDark() ? "linedShadowDInfo" : "linedShadowLInfo"}>
                                                <List style={{paddingTop: '1px', paddingBottom: '1px'}}>
                                                    <ListItem style={{padding: '3px'}}>
                                                        <Button style={{padding: '2px',width: '100%',placeContent: 'space-between'}} onClick={this.addReact.bind(this,'like')}>
                                                            <Add/>
                                                            <Box style={{display: 'flex'}}>
                                                                <Typography style={{fontFamily: "'Changa'",fontSize: "small", alignSelf: "center", marginRight: "4px",opacity: '0.6'}}>
                                                                    ({this.state.infoData.reaction[0]})
                                                                </Typography>
                                                                <Typography style={{fontFamily: "'Changa'",marginRight: '4px'}}>
                                                                    أعجبني
                                                                </Typography>
                                                                <img src={this.state.pokemon.like} style={{width: '28px',height: '28px'}} alt={"like"}/>
                                                            </Box>
                                                        </Button>
                                                    </ListItem>
                                                    <ListItem style={{padding: '3px'}}>
                                                        <Button style={{padding: '2px',width: '100%',placeContent: 'space-between'}} onClick={this.addReact.bind(this,'love')}>
                                                            <Add/>
                                                            <Box style={{display: 'flex'}}>
                                                                <Typography style={{fontFamily: "'Changa'",fontSize: "small", alignSelf: "center", marginRight: "4px",opacity: '0.6'}}>
                                                                    ({this.state.infoData.reaction[1]})
                                                                </Typography>
                                                                <Typography style={{fontFamily: "'Changa'",marginRight: '4px'}}>
                                                                    أحببته
                                                                </Typography>
                                                                <img src={this.state.pokemon.love} style={{width: '28px',height: '28px'}} alt={"love"}/>
                                                            </Box>
                                                        </Button>
                                                    </ListItem>
                                                    <ListItem style={{padding: '3px'}}>
                                                        <Button style={{padding: '2px',width: '100%',placeContent: 'space-between'}} onClick={this.addReact.bind(this,'haha')}>
                                                            <Add/>
                                                            <Box style={{display: 'flex'}}>
                                                                <Typography style={{fontFamily: "'Changa'",fontSize: "small", alignSelf: "center", marginRight: "4px",opacity: '0.6'}}>
                                                                    ({this.state.infoData.reaction[2]})
                                                                </Typography>
                                                                <Typography style={{fontFamily: "'Changa'",marginRight: '4px'}}>
                                                                    أضحكني
                                                                </Typography>
                                                                <img src={this.state.pokemon.haha} style={{width: '28px',height: '28px'}} alt={"haha"}/>
                                                            </Box>
                                                        </Button>
                                                    </ListItem>
                                                    <ListItem style={{padding: '3px'}}>
                                                        <Button style={{padding: '2px',width: '100%',placeContent: 'space-between'}} onClick={this.addReact.bind(this,'wow')}>
                                                            <Add/>
                                                            <Box style={{display: 'flex'}}>
                                                                <Typography style={{fontFamily: "'Changa'",fontSize: "small", alignSelf: "center", marginRight: "4px",opacity: '0.6'}}>
                                                                    ({this.state.infoData.reaction[3]})
                                                                </Typography>
                                                                <Typography style={{fontFamily: "'Changa'",marginRight: '4px'}}>
                                                                    أدهشني
                                                                </Typography>
                                                                <img src={this.state.pokemon.wow} style={{width: '28px',height: '28px'}} alt={"wow"}/>
                                                            </Box>
                                                        </Button>
                                                    </ListItem>
                                                    <ListItem style={{padding: '3px'}}>
                                                        <Button style={{padding: '2px',width: '100%',placeContent: 'space-between'}} onClick={this.addReact.bind(this,'sad')}>
                                                            <Add/>
                                                            <Box style={{display: 'flex'}}>
                                                                <Typography style={{fontFamily: "'Changa'",fontSize: "small", alignSelf: "center", marginRight: "4px",opacity: '0.6'}}>
                                                                    ({this.state.infoData.reaction[4]})
                                                                </Typography>
                                                                <Typography style={{fontFamily: "'Changa'",marginRight: '4px'}}>
                                                                    أحزنني
                                                                </Typography>
                                                                <img src={this.state.pokemon.sad} style={{width: '28px',height: '28px'}} alt={"sad"}/>
                                                            </Box>
                                                        </Button>
                                                    </ListItem>
                                                    <ListItem style={{padding: '3px'}}>
                                                        <Button style={{padding: '2px',width: '100%',placeContent: 'space-between'}} onClick={this.addReact.bind(this,'angry')}>
                                                            <Add/>
                                                            <Box style={{display: 'flex'}}>
                                                                <Typography style={{fontFamily: "'Changa'",fontSize: "small", alignSelf: "center", marginRight: "4px",opacity: '0.6'}}>
                                                                    ({this.state.infoData.reaction[5]})
                                                                </Typography>
                                                                <Typography style={{fontFamily: "'Changa'",marginRight: '4px'}}>
                                                                    أغضبني
                                                                </Typography>
                                                                <img src={this.state.pokemon.angry} style={{width: '28px',height: '28px'}} alt={"angry"}/>
                                                            </Box>
                                                        </Button>
                                                    </ListItem>
                                                </List>
                                            </Card>
                                        </Container>
                                    </ListItem>
                                    {
                                        this.state.infoData.youtube_image.toString().length > 1 ? <ListItem>
                                            <Box className={"titleHeader"} sx={{marginTop:"8px"}}>
                                                <Button size="medium" disabled={true} style={{color: "white"}}>
                                                    <span/>
                                                </Button>
                                                <div>
                                                    <span style={{fontFamily: "Changa",fontSize: "17px"}}>عرض الأنمي</span>
                                                </div>
                                            </Box>
                                        </ListItem> : <Box/>
                                    }
                                    {youtube}
                                    <ListItem>
                                        {window.main.checkLoggedAndPremium() ? <Box/> : <div id="bannerAds"/>}
                                    </ListItem>
                                </List>
                            </Grow>
                        </CustomTabPanel>
                        <CustomTabPanel value={this.state.tabValue} index={1}>
                            <Grow in={this.state.tabValue === 1}>
                                <List dense sx={{ padding: "2px 0px 8px 0px" }}>
                                    {this.state.infoData.ep.length === 0 ? (
                                        <Container>
                                            <List>
                                                <ListItem style={{ padding: "0px", placeContent: "center" }}>
                                                    <Typography style={{ fontFamily: "'Changa'", textAlign: "center" }}>
                                                        الحلقات غير متوفرة حاليا
                                                    </Typography>
                                                </ListItem>
                                                <ListItem style={{ padding: "0px" }}>
                                                    <ListItem
                                                        onClick={this.goSendRequest}
                                                        button
                                                        style={{
                                                            margin: "7px",
                                                            borderRadius: "8px",
                                                            textAlign: "center",
                                                            placeContent: "center",
                                                            backgroundColor: "#2196f3",
                                                        }}
                                                    >
                                                        <Typography style={{ fontFamily: "'Changa'", color: "white" }}>
                                                            أرسال طلب رفع
                                                        </Typography>
                                                    </ListItem>
                                                </ListItem>
                                            </List>
                                        </Container>
                                    ) : (
                                        <>
                                            {this.state.infoData.ep.flat().length > 500 && (
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    placeholder="ابحث عن حلقة..."
                                                    value={this.state.searchQuery || ""}
                                                    onChange={(e) => {
                                                        const query = e.target.value;
                                                        this.setState({ searchQuery: query }, () => {
                                                            if (!query) return;
                                                            const allEps = this.state.infoData.ep.flat();

                                                            // Extract numbers from episode name
                                                            const foundIndex = allEps.findIndex((ep) => {
                                                                const match = ep.name.match(/\d+/); // get the first number in name
                                                                return match && match[0] === query.trim();
                                                            });

                                                            if (foundIndex !== -1) {
                                                                const pageSize = this.state.infoData.ep[0].length; // episodes per page
                                                                const page = Math.floor(foundIndex / pageSize) + 1;
                                                                this.setState({ infoEpPage: page }, () => {
                                                                    const el = document.getElementById(`ep-${allEps[foundIndex].id}`);
                                                                    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
                                                                });
                                                            }
                                                        });
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            backgroundColor: this.isDark() ? "#1f2a33" : "#f1f1f1",
                                                            borderRadius: "8px",
                                                            color: this.isDark() ? "#fff" : "#000",
                                                        },
                                                    }}
                                                />
                                            )}

                                            {this.state.infoData.ep.flat().length > 500 && (
                                                <div style={{height: 10}}/>
                                            )}
                                            {/* Episodes on current page */}
                                            {this.state.infoData.ep[this.state.infoEpPage - 1].map((item) => (
                                                <ListItem
                                                    id={`ep-${item.id}`}
                                                    style={{
                                                        paddingTop: "2px",
                                                        paddingBottom: "2px",
                                                        paddingLeft: "4px",
                                                        paddingRight: "4px",
                                                    }}
                                                    key={item.id}
                                                >
                                                    <Button
                                                        onClick={this.showEp.bind(this, item)}
                                                        className={this.isDark() ? "linedShadowDInfo" : "linedShadowLInfo"}
                                                        style={{
                                                            width: "100%",
                                                            placeContent: "space-between",
                                                            textTransform: "none",
                                                        }}
                                                        endIcon={
                                                            this.checkWatch(item.id, item.name) ? (
                                                                <Visibility sx={{ color: "#2196f3" }} />
                                                            ) : (
                                                                <VisibilityOutlined />
                                                            )
                                                        }
                                                    >
                                                        {item.name}
                                                    </Button>
                                                </ListItem>
                                            ))}

                                            {/* Pagination */}
                                            {this.state.infoData.ep.length > 1 && (
                                                <Box>
                                                    <Pagination
                                                        className={"centerPage"}
                                                        style={{ placeContent: "center" }}
                                                        siblingCount={0}
                                                        size="large"
                                                        color={"primary"}
                                                        page={this.state.infoEpPage}
                                                        onChange={this.infoEpChanged}
                                                        count={this.state.infoData.ep.length}
                                                        variant="outlined"
                                                        shape="rounded"
                                                    />
                                                </Box>
                                            )}
                                        </>
                                    )}
                                </List>
                            </Grow>
                        </CustomTabPanel>
                        <CustomTabPanel value={this.state.tabValue} index={2}>
                            <Grow in={this.state.tabValue === 2}>
                                <Box>
                                    <Box style={{marginBottom: '7px'}}>
                                        {this.state.commentLoading ? <Container style={{placeContent: 'center',textAlign: 'center',height: '100%'}}>
                                            <GifLoader size={50} style={"margin-top: 10px;"} />
                                        </Container> : <Grow in={!this.state.commentLoading}>
                                            <List style={{paddingTop: '0px', paddingBottom: '0px',paddingLeft: "0px", paddingRight: "0px"}}>
                                                {this.state.commentData.length === 0 ? <CenterEmpty/> : this.state.commentData[this.state.commentPage - 1].map((item,index) =>
                                                        <ListItem style={{paddingLeft: "7px", paddingRight: "7px"}} key={item.id}>
                                                            <Card elevation={0} sx={{ width: "100%",borderRadius: "8px",backgroundColor: "transparent" }} className={this.isDark() ? "linedShadowDInfo" : "linedShadowLInfo"}>
                                                                <CardHeader
                                                                    avatar={
                                                                        item.admin.toString().includes("true") ? <Tooltip title="الأدارة">
                                                                            <Badge anchorOrigin={{
                                                                                vertical: 'bottom',
                                                                                horizontal: 'right',
                                                                            }} badgeContent={<Done style={{color: 'white'}} sx={{ fontSize: 12 }}/>} overlap="circular" sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 14, minWidth: 14, width: 14, backgroundColor: "#00b2ff"}}}>
                                                                                <Avatar aria-label="recipe" src={item.userimage}/>
                                                                            </Badge>
                                                                        </Tooltip> : <Avatar aria-label="recipe" src={item.userimage}/>
                                                                    }
                                                                    title={item.hasPremium !== "1" ? item.username : <Box>
                                                                        <span style={{color: "gold", textShadow: '0px 0px 5px #ffeb3b'}}>
                                                                            {item.username}
                                                                        </span>
                                                                    </Box>}
                                                                    subheader={<Typography style={{fontSize: "14px",opacity: "0.8"}}>{item.time}</Typography>}
                                                                    action={
                                                                        <IconButton id={item.id} onClick={this.reportCmd}>
                                                                            <MoreVertOutlined/>
                                                                        </IconButton>
                                                                    }
                                                                />
                                                                {this.state.menuId === item.id ? <Menu
                                                                    id={item.id}
                                                                    anchorEl={this.state.anchorEl}
                                                                    open={this.state.menuOpen}
                                                                    onClose={this.closeMenus}
                                                                    MenuListProps={{
                                                                        'aria-labelledby': item.id,
                                                                    }}
                                                                    TransitionComponent={Fade}
                                                                >
                                                                    <MenuItem onClick={this.sendReport.bind(this,item)}>
                                                                        <ListItemIcon>
                                                                            <ReportOutlined fontSize="small" />
                                                                        </ListItemIcon>
                                                                        <ListItemText>أبلاغ عن التعليق</ListItemText>
                                                                    </MenuItem>
                                                                    {
                                                                        this.isAdmin() ? <MenuItem onClick={this.deleteCmdAnime.bind(this,item)}>
                                                                            <ListItemIcon>
                                                                                <DeleteOutline fontSize="small" />
                                                                            </ListItemIcon>
                                                                            <ListItemText>حذف التعليق</ListItemText>
                                                                        </MenuItem> : <Box/>
                                                                    }
                                                                </Menu> : <Box/> }
                                                                <CardContent style={{textAlign: "unset"}} dir="auto">
                                                                    {
                                                                        item.hasFire ? <Button style={{width: "100%",color: "#ff0000"}} onClick={this.changeFire.bind(this,index)}>التعليق يحتوي على حرق (اضغط للمشاهدة)</Button> :
                                                                            <Typography style={{width: "100%",textAlign: "initial",whiteSpace: "pre-line",overflow: "hidden"}} dir="auto" aria-multiline={true}>
                                                                                {item.post}
                                                                            </Typography>
                                                                    }
                                                                </CardContent>
                                                            </Card>
                                                        </ListItem>
                                                )}
                                            </List>
                                        </Grow> }
                                    </Box>
                                    {this.state.commentData.length === 1 ? <Box/> :  this.state.commentData.length === 0 ? <Box/> : <Pagination className={"centerPage"} style={{placeContent: "center"}} siblingCount={0} size="large" color={"primary"} page={this.state.commentPage} onChange={this.commentPageChanged} count={this.state.commentData.length} variant="outlined" shape="rounded" />}
                                </Box>
                            </Grow>
                        </CustomTabPanel>
                    </Box>
                    {
                        <Box sx={{height: "13vh"}}/>
                    }
                </Box>
                <Dialog
                    fullWidth
                    open={this.state.commentAdd}
                    onClose={this.onCloseMenu}
                    TransitionComponent={Transition}
                    PaperProps={{
                        sx: {
                            margin: "0px",
                            top: "auto",
                            right: "auto",
                            bottom: "20px",
                            left: "auto",
                            position: "fixed",
                            background: "transparent",
                            boxShadow: "unset"
                        }
                    }}
                >
                    <Box>
                        <Paper
                            component="form"
                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center',borderRadius: "100px" }}
                        >
                            <InputBase
                                id={"inputComment"}
                                sx={{ ml: 1, flex: 1,borderRadius: "100px",direction:"rtl" }}
                                placeholder="اكتب تعليقك"
                                onChange={(value) => {
                                    this.setState({
                                        postComment: {
                                            post: value.target.value,
                                            id: this.state.infoData.id,
                                            fire: value.target.checked
                                        },
                                    });
                                }}
                                onClick={() => {
                                    setTimeout(() => {
                                        $("html").animate({ scrollTop: -10000 }, 500);
                                        $("body").animate({ scrollTop: -10000 }, 500);
                                    },200);
                                }}
                                inputProps={{ 'aria-label': 'type' }}
                            />
                            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                            <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions" onClick={this.sendCmd}>
                                <SendOutlined />
                            </IconButton>
                        </Paper>
                        <Box sx={{height: "10px"}}/>
                        <Paper
                            component="form"
                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center',borderRadius: "100px" }}
                        >
                            <ListItemText sx={{ ml: 1, flex: 1,borderRadius: "100px" }} id="switch-list-label-wifi" primary="يحتوي على حرق" />
                            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                            <Switch
                                sx={{ m: 0.5 }}
                                checked={this.state.postComment.fire}
                                onChange={(value) => {
                                    this.setState({
                                        postComment: {
                                            post: this.state.postComment.post,
                                            id: this.state.infoData.id,
                                            fire: value.target.checked
                                        },
                                    });
                                }}
                                inputProps={{ 'aria-label': 'hasFire' }}
                            />
                        </Paper>
                    </Box>
                </Dialog>
                <Zoom
                    in={this.state.tabValue === 0}
                    timeout={300}
                    unmountOnExit
                >
                    <Fab onClick={() => {
                        if (this.state.infoData.ep.length !== 0) {
                            this.showEp(this.state.infoData.ep[0][0]);
                        }
                    }} className={"fab"} variant="extended" sx={{fontFamily: "Changa",backgroundColor: "primary.cardTwo",color: "primary.card"}} aria-label={"شاهد"}>
                        {
                            this.state.infoData.ep.length === 0 ? "لاتوجد حلقات" : this.state.infoData.ep[0][0].name
                        }
                    </Fab>
                </Zoom>
                <Zoom
                    in={this.state.tabValue === 2}
                    timeout={300}
                    unmountOnExit
                >
                    <Fab onClick={this.openMenu} className={"fab"} variant="extended" sx={{fontFamily: "Changa",backgroundColor: "primary.cardTwo",color: "primary.card"}} aria-label={"add comment"}>
                        {
                            "اضافة تعليق"
                        }
                    </Fab>
                </Zoom>
                <BottomSheet
                    contentStyle={this.isDark() ? {backgroundColor: "#252e39"} : {backgroundColor: "white"}}
                    onRequestClose={() => this.closeMenu()}
                    open={this.state.epMenu}>
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton onClick={this.open.bind(this,1)}>
                                <ListItemIcon>
                                    <PlayCircleOutline />
                                </ListItemIcon>
                                <ListItemText primary="تشغيل" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={this.open.bind(this,2)}>
                                <ListItemIcon>
                                    <DownloadOutlined />
                                </ListItemIcon>
                                <ListItemText primary="تنزيل" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </BottomSheet>
                <BottomSheet
                    contentStyle={this.isDark() ? {backgroundColor: "#252e39"} : {backgroundColor: "white"}}
                    onRequestClose={() => this.epMenu4Close()}
                    open={this.state.epMenu4}>
                    <List>
                        {
                            this.state.epMenu4List.map((post) => {
                                    return <ListItem key={post.name} disablePadding>
                                        <ListItemButton onClick={() => {
                                            window.localStorage.setItem("webUrl",post.url);
                                            window.localStorage.setItem("videoName",this.state.infoData.title + " " + this.state.animeEpName);
                                            window.main.goLink("/playerWeb");
                                        }}>
                                            <ListItemIcon>
                                                <PlayCircleOutline />
                                            </ListItemIcon>
                                            <ListItemText primary={post.name} />
                                        </ListItemButton>
                                    </ListItem>;
                            })
                        }
                    </List>
                </BottomSheet>
                <BottomSheet
                    contentStyle={this.isDark() ? {backgroundColor: "#252e39"} : {backgroundColor: "white"}}
                    onRequestClose={() => this.epMenu2Close()}
                    open={this.state.epMenu2}>
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => {
                                if (window.navigator.userAgent.includes("SAnimeWeb")) {
                                    if (this.state.isDownload) {
                                        let item = JSON.parse("{}");
                                        item.type = "openUrl";
                                        item.url = this.state.epLink.hd + "?download=true";
                                        window.chrome.webview.postMessage(JSON.stringify(item));
                                        return;
                                    }
                                }
                                if (!window.main.checkLoggedAndPremium()) {
                                    window.showingAds = window.showingAds || 0;
                                    if (window.main.ios()) {
                                        //window.showingAds++;
                                        //if (window.showingAds >= window.showAds) {
                                        //    window.showingAds = 0;
                                            window.webkit.messageHandlers.callback.postMessage(JSON.stringify({
                                                type: "shad"
                                            }));
                                        //}
                                        setTimeout(() => {
                                            let item = JSON.parse("{}");
                                            item["value"] = window.main.checkLoggedAndPremium() ? "false" : "true";
                                            item["type"] = "ads";
                                            if (window.main.ios()) {
                                                window.webkit.messageHandlers.callback.postMessage(JSON.stringify(item));
                                            }
                                        },1000);
                                    }
                                }
                                this.setState({
                                    isHd:true,
                                    epMenu2:false,
                                    epMenu3:true
                                });
                            }}>
                                <ListItemIcon>
                                    <HdOutlined />
                                </ListItemIcon>
                                <ListItemText primary="الدقة العالية" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => {
                                if (window.navigator.userAgent.includes("SAnimeWeb")) {
                                    if (this.state.isDownload) {
                                        let item = JSON.parse("{}");
                                        item.type = "openUrl";
                                        item.url = this.state.epLink.sd + "?download=true";
                                        window.chrome.webview.postMessage(JSON.stringify(item));
                                        return;
                                    }
                                }
                                if (!window.main.checkLoggedAndPremium()) {
                                    window.showingAds = window.showingAds || 0;
                                    if (window.main.ios()) {
                                        //window.showingAds++;
                                        //if (window.showingAds >= window.showAds) {
                                            //window.showingAds = 0;
                                            window.webkit.messageHandlers.callback.postMessage(JSON.stringify({
                                                type: "shad"
                                            }));
                                        //}
                                        setTimeout(() => {
                                            let item = JSON.parse("{}");
                                            item["value"] = window.main.checkLoggedAndPremium() ? "false" : "true";
                                            item["type"] = "ads";
                                            if (window.main.ios()) {
                                                window.webkit.messageHandlers.callback.postMessage(JSON.stringify(item));
                                            }
                                        },1000);
                                    }
                                }
                                this.setState({
                                    isHd:false,
                                    epMenu2:false,
                                    epMenu3:true
                                });
                            }}>
                                <ListItemIcon>
                                    <SdOutlined />
                                </ListItemIcon>
                                <ListItemText primary="الدقة الضعيفة" />
                            </ListItemButton>
                        </ListItem>
                        {
                            this.state.isDownload ? <div style={{display: "none"}}/> :  <ListItem disablePadding>
                                <ListItemButton onClick={() => {
                                    if (!window.main.checkLoggedAndPremium()) {
                                        window.showingAds = window.showingAds || 0;
                                        if (window.main.ios()) {
                                            window.webkit.messageHandlers.callback.postMessage(JSON.stringify({
                                                type: "shad"
                                            }));
                                            setTimeout(() => {
                                                let item = JSON.parse("{}");
                                                item["value"] = window.main.checkLoggedAndPremium() ? "false" : "true";
                                                item["type"] = "ads";
                                                if (window.main.ios()) {
                                                    window.webkit.messageHandlers.callback.postMessage(JSON.stringify(item));
                                                }
                                            },1000);
                                            //window.showingAds++;
                                            //if (window.showingAds >= window.showAds) {
                                            //    window.showingAds = 0;
                                            //    window.webkit.messageHandlers.callback.postMessage(JSON.stringify({
                                            //        type: "shad"
                                            //    }));
                                            //}
                                            //setTimeout(() => {
                                            //    let item = JSON.parse("{}");
                                            //    item["value"] = window.main.checkLoggedAndPremium() ? "false" : "true";
                                            //    item["type"] = "ads";
                                            //    if (window.main.ios()) {
                                            //        window.webkit.messageHandlers.callback.postMessage(JSON.stringify(item));
                                            //    }
                                            //},500);
                                        }
                                    }
                                    this.setState({
                                        isHd:false,
                                        epMenu2:false,
                                        epMenu3:false
                                    });
                                    window.main.switchLoading();
                                    fetch('https://app.sanime.net/function/h10.php?page=getOther&id='+this.state.infoData.id+"&name="+this.state.mainItem.name+"&epId="+this.state.mainItem.id).then((value) => {
                                        window.main.switchLoading();
                                        value.text().then((value) => {
                                            if (value.length === 0) {
                                                // eslint-disable-next-line no-undef
                                                Swal.fire(
                                                    "لاتوجد روابط خارجية لهذا الحلقة"
                                                );
                                            } else {
                                                if (value === "null") {
                                                    // eslint-disable-next-line no-undef
                                                    Swal.fire(
                                                        "لاتوجد روابط خارجية لهذا الحلقة"
                                                    );
                                                } else {
                                                    const data = JSON.parse(value);
                                                    if (data.length === 0) {
                                                        // eslint-disable-next-line no-undef
                                                        Swal.fire(
                                                            "لاتوجد روابط خارجية لهذا الحلقة"
                                                        );
                                                    } else {
                                                        this.setState({
                                                            epMenu4List: data,
                                                            epMenu4:true
                                                        });
                                                    }
                                                }
                                            }
                                        });
                                    }).catch((er) => {
                                        window.main.switchLoading();
                                    });
                                }}>
                                    <ListItemIcon>
                                        <LinkRounded />
                                    </ListItemIcon>
                                    <ListItemText primary="سيرفرات خارجية/دقات أخرى" />
                                </ListItemButton>
                            </ListItem>
                        }
                    </List>
                </BottomSheet>
                <BottomSheet
                    contentStyle={this.isDark() ? {backgroundColor: "#252e39"} : {backgroundColor: "white"}}
                    onRequestClose={() => this.epMenu3Close()}
                    open={this.state.epMenu3}>
                    <List>
                        {
                            this.state.isDownload ? <div>
                                <ListItem disablePadding>
                                    <ListItemButton onClick={this.open.bind(this,7)}>
                                        <ListItemIcon>
                                            <DownloadOutlined />
                                        </ListItemIcon>
                                        <ListItemText primary={ window.main.isOtakuTime() ? "تطبيق اوتاكو تايم" : "تطبيق أس أنمي" } />
                                    </ListItemButton>
                                </ListItem>
                                { window.main.isOtakuTime() ? <div/> : <ListItem disablePadding>
                                    <ListItemButton onClick={this.open.bind(this,8)}>
                                        <ListItemIcon>
                                            <DownloadOutlined />
                                        </ListItemIcon>
                                        <ListItemText primary="تطبيق ADM" />
                                    </ListItemButton>
                                </ListItem> }
                                { window.main.isOtakuTime() ? <div/> : <ListItem disablePadding>
                                    <ListItemButton onClick={this.open.bind(this,9)}>
                                        <ListItemIcon>
                                            <DownloadOutlined />
                                        </ListItemIcon>
                                        <ListItemText primary="تطبيق أخر" />
                                    </ListItemButton>
                                </ListItem> }
                            </div> : <div>
                                <ListItem disablePadding>
                                    <ListItemButton onClick={this.open.bind(this,10)}>
                                        <ListItemIcon>
                                            <PlayCircleOutline />
                                        </ListItemIcon>
                                        <ListItemText primary={ window.main.isOtakuTime() ? "مشغل اوتاكو تايم" : "مشغل أس أنمي" } />
                                    </ListItemButton>
                                </ListItem>
                                { window.main.isOtakuTime() ? <div/> : <ListItem disablePadding>
                                    <ListItemButton onClick={this.open.bind(this,11)}>
                                        <ListItemIcon>
                                            {
                                                window.main.ios() ? <ContentCopyOutlined /> : <PlayCircleOutline />
                                            }
                                        </ListItemIcon>
                                        <ListItemText primary={window.main.ios() ? "نسخ الحلقة" : "مشغل خارجي"} />
                                    </ListItemButton>
                                </ListItem> }
                            </div>
                        }
                    </List>
                </BottomSheet>
            </Box>);
        }
    }
}
export default InfoPage;
